module.exports = __webpack_public_path__ + "img/e587f2b.gif";